import { Button, Td, Textarea, Tr, useColorModeValue } from "@chakra-ui/react";
import React from "react";

const TransactionCard = ({ transactionId, time, price, type, borderColor, textColor }) => {
  // Fallback colors if props aren't passed (though they should be)
  const defaultBorderColor = useColorModeValue("gray.200", "gray.700");
  const defaultTextColor = useColorModeValue("gray.900", "white");
  const inputBg = useColorModeValue("white", "gray.700");

  const finalBorderColor = borderColor || defaultBorderColor;
  const finalTextColor = textColor || defaultTextColor;

  return (
    <>
      <Tr>
        <Td
          fontSize={['0.9rem', '0.95rem', '1rem', '1rem']}
          pb={["0.5rem !important", "0.6rem !important", "0.7rem !important", "0.7rem !important"]}
          pt={["0.5rem !important", "0.6rem !important", "0.7rem !important", "0.7rem !important"]}
          borderBottomWidth="1px"
          borderColor={finalBorderColor}
          color={finalTextColor}
        >
          ₹{price}
        </Td>
        <Td
          fontSize={['0.9rem', '0.95rem', '1rem', '1rem']}
          pb={["0.5rem !important", "0.6rem !important", "0.7rem !important", "0.7rem !important"]}
          pt={["0.5rem !important", "0.6rem !important", "0.7rem !important", "0.7rem !important"]}
          borderBottomWidth="1px"
          borderColor={finalBorderColor}
          color={finalTextColor}
        >
          <Textarea
            readOnly={true}
            value={transactionId}
            w={['13rem', '16rem', '100%', "100%"]}
            size={['sm', "sm", 'md', 'md']}
            bg={inputBg}
            borderColor={finalBorderColor}
            color={finalTextColor}
            _focus={{ borderColor: "#319795" }}
          />
        </Td>
        <Td
          fontSize={['0.9rem', '0.95rem', '1rem', '1rem']}
          pb={["0.5rem !important", "0.6rem !important", "0.7rem !important", "0.7rem !important"]}
          pt={["0.5rem !important", "0.6rem !important", "0.7rem !important", "0.7rem !important"]}
          borderBottomWidth="1px"
          borderColor={finalBorderColor}
          color={finalTextColor}
        >
          {type}
        </Td>
        <Td
          fontSize={['0.9rem', '0.95rem', '1rem', '1rem']}
          pb={["0.5rem !important", "0.6rem !important", "0.7rem !important", "0.7rem !important"]}
          pt={["0.5rem !important", "0.6rem !important", "0.7rem !important", "0.7rem !important"]}
          borderBottomWidth="1px"
          borderColor={finalBorderColor}
          color={finalTextColor}
        >
          {time}
        </Td>
      </Tr>
    </>
  );
};

export default TransactionCard;
